var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u65B0\u5EFA\u6807\u4E66") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-131.000000, -1521.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0\\u5EFA\\u6807\\u4E66",
    transform: "translate(131.000000, 1521.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52000045,2.54068021 C1.51963995,1.99946549 1.73443026,1.48030388 2.11706317,1.09754342 C2.49969608,0.714782969 3.01878608,0.499819642 3.56000089,0.500000114 L12.4000008,0.500000114 C12.5803333,0.500000114 12.7532658,0.571706652 12.8807608,0.699240226 L16.2807608,4.0992402 C16.4082944,4.22673526 16.4800008,4.39966773 16.4800008,4.5800002 L16.4800008,15.4634001 C16.4800008,16.5881201 15.5650608,17.5000001 14.4400008,17.5000001 L3.56000089,17.5000001 C3.01884142,17.5000001 2.49985636,17.2849788 2.1172626,16.9022576 C1.73466884,16.5195363 1.51982052,16.0004796 1.52000045,15.4593201 L1.52000045,2.54068021 L1.52000045,2.54068021 Z M15.1200008,4.8615202 L12.1184808,1.86000022 L3.55966089,1.86000022 C3.1836209,1.86000022 2.88000056,2.16396022 2.88000056,2.54068021 L2.88000056,15.4593201 C2.87982043,15.6397851 2.95138341,15.8129205 3.07892771,15.9405924 C3.20647201,16.0682642 3.3795358,16.1400001 3.56000089,16.1400001 L14.4400008,16.1400001 C14.8146808,16.1400001 15.1200008,15.8360401 15.1200008,15.4634001 L15.1200008,4.8615202 Z M5.59999233,9.00000017 C5.59999233,8.62577033 5.90237571,8.32187132 6.27660088,8.32000018 L11.7234008,8.32000018 C12.0970608,8.32000018 12.4000008,8.62192017 12.4000008,9.00000017 C12.4000008,9.37423001 12.097626,9.67812902 11.7234008,9.68000017 L6.27660088,9.68000017 C6.09656476,9.68000017 5.92395163,9.60825147 5.79696633,9.48062805 C5.66998102,9.35300463 5.59909618,9.18003402 5.59999233,9.00000017 Z M9.00000086,5.60000019 C9.3742307,5.60000019 9.6781297,5.90237502 9.68000085,6.27660019 L9.68000085,11.7234002 C9.68000085,12.0970601 9.37808085,12.4000001 9.00000086,12.4000001 C8.62577102,12.4000001 8.32187201,12.0976253 8.32000086,11.7234002 L8.32000086,6.27660019 C8.32000086,5.90294019 8.62192086,5.60000019 9.00000086,5.60000019 Z",
    id: "\\u5F62\\u72B6",
    fill: "#26292C",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/新建标书.3417098b594520589b1be96bba78acef.svg";
export { ForwardRef as ReactComponent };